<template>
  <div class="projectTeam">
    <div v-for="(item , index ) in ueserList" :key="index" :class="[{ teamContain: showPutAway(item) }]">
      <template v-if="showPutAway(item)">
        <div class="headerTitle">
          <div class="titleAway">{{item.roleItemName}}({{item.userNum}}人)</div>
          <div class="putAway" @click="putAway(index)" v-if="showPutAway(item)&&item.shrink">收起<i class="el-icon-arrow-up"></i></div>
          <div class="putAway" @click="putAway(index)" v-if="showPutAway(item)&&!item.shrink">展开<i class="el-icon-arrow-down"></i></div>
        </div>
        <ul class="content" v-if="item.code!='1'&&item.shrink">
          <li v-for="(insider , index ) in item.insiderList" :key="index">
            <img :src="insider.img" alt="头像" @error="errorImg()">
            <div class="label" :title="insider.roleName">{{insider.roleName}}</div>
            <div>
              <div class="contentName">{{insider.userName}}</div>
              <div class="contentLabel">{{insider.deptName}}</div>
            </div>
          </li> 
        </ul>
        <template v-if="item.code==='1'&&item.shrink">
          <div v-for="{company,index,userList} in item.outsiderList" :key="index">
            <div class="companyClass">{{company}}</div>
            <div  class="content">
              <li v-for="(outsider , index ) in userList" :key="index">
                <img :src="outsider.img" alt="头像" @error="errorImg()">
                <div class="label" :title="outsider.roleName">{{outsider.roleName}}</div>
                <div style="flex-grow:1; min-width:0px;">
                  <div class="contentName">{{outsider.userName}}</div>
                  <div class="contentLabel" :title="outsider.phone">{{outsider.phone}}</div>
                  <div class="contentLabel" :title="outsider.email">{{outsider.email}}</div>
                </div>
              </li>
            </div>
          </div> 
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import projectHome from "@/xgzdService/projectHome-service";
import { mapState } from "vuex";
import { gettouxAvatar } from '@/CommonDP/utils/index';
export default {
  props:{
    allkey:{
      type: Number,
      required: false
    }
  },
  data(){
    return{
      noProjectImage:require('@/views/assets/head.png'),
      ueserList:[],
    }
  },
  computed:{
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
    }),
  },
  mounted(){
    this.getPersonList()
  },
  methods:{
    errorImg() {
      let img = event.srcElement
      img.src = this.noProjectImage
      img.onerror = null //防止闪图
    },
    showPutAway(item){
      const insider=item.code!='1'&&item.insiderList&&item.insiderList.length>0
      const outsider=item.code ==='1'&&item.outsiderList&&item.outsiderList.length>0
      return insider||outsider
    },
    async getPersonList(){
      const { prjId } =this.prjInfo;
      const { data } =await projectHome.getprjPersonAll(prjId);
      this.ueserList=data.map((item)=>{
        return{
          shrink:true,
          ...item
        }
      })
      for (const item of data) {
        if(item.insiderList&&item.insiderList.length>0){
          for (const user of item.insiderList) this.getAvatar(user)
        }else if(item.outsiderList&&item.outsiderList.length>0){
          for (const out of item.outsiderList){
            if(out.userList&&out.userList.length>0){
              for (const user of out.userList) this.getAvatar(user)
            }
          } 
        }
      }  
    },
     getAvatar(item){
      const { userId } = item;
      const data = gettouxAvatar(userId)
      if(data)this.$set(item, 'img', data)
    },
    putAway(index){
      this.ueserList[index].shrink=!this.ueserList[index].shrink
    }
  }
}
</script>

<style lang="scss" scoped>
.projectTeam{
  width: 100%;
  height: 100%;
  margin-top: 14px;
  overflow-y: auto;
}
.teamContain{
   margin-bottom: 10px;
  .headerTitle{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .putAway{
      width: 58px;
      height: 26px;
      border-radius: 5px;
      background: #fff;
      line-height: 22px;
      font-size: 14px;
      padding: 2px;
      text-align: center;
      cursor: pointer;
      color: #859AD0;
    }
    .titleAway{
      font-size: 16px;
      line-height: 16px;
      padding-left: 10px;
      border-left: 3px solid #3370FF;
    }
  }
  .companyClass{
    font-size: 14px;
    line-height: 24px;
  }
  .content{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    li{
      width: 260px;
      padding: 0px 10px;
      height: 95px;
      border-radius: 5px;
      background: #ffffff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 11px;
      position: relative;
      margin-right: 15px;
      margin-bottom: 15px;
      img{
        width: 66px;
        height: 66px;
        border-radius: 50%;
        margin-right: 4px;
      }
      .label{
        position: absolute;
        top: 0;
        right: 0;
        background: #7B8CAF;
        font-size: 13px;
        color: #ffffff;
        line-height: 20px;
        padding: 0 4px;
        border-radius: 0 5px 0 5px;
        width: 38%;
        text-align: center;
        white-space:nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: pointer;
      }
      .contentName{
        color: #333333;
        font-size: 15px;
        line-height: 32px;
      }
      .contentLabel{
        color: #5b9dd5;
        font-weight: bold;
        font-size: 12px;
        overflow: hidden; 
        width: 100%;
        cursor: pointer;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; 
      }
    }
  }
}
</style>
